import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Collapse } from "@material-ui/core";
import OrSpinner from "../../../../../Components/Utils/OrSpinner";
import { ListarDocumentoTemplateFormularioController } from "../../../../../Controllers/Automacao/Formularios/ConfigTemplateFormulario/ConfigTemplateFormularioControllers";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import useToggle from "../../../../../hooks/useToggle";
import CriarConfiguracaoTemplateFormulario from "./CriarConfiguracaoTemplateFormulario";
import LabelVinculoFormularioTemplate from "./LabelVinculoFormularioTemplate";

interface IConfiguracaoTemplateDoFormularioProps {
    idFormulario: number;
}

export default function ConfiguracaoTemplateDoFormulario(
    props: IConfiguracaoTemplateDoFormularioProps
) {
    const [adicionandoConfiguracao, toggleAdicionandoConfiguracao] =
        useToggle(false);
    const {
        loading,
        value: lstTemplateVinculadosAoFormulario,
        execute: updateList,
    } = useAsyncEffect(
        async () =>
            ListarDocumentoTemplateFormularioController(props.idFormulario),
        [props.idFormulario]
    );

    return (
        <div>
            <div className="d-flex justify-content-center w-100 align-items-center mt-n5 mb-3">
                <button
                    type="button"
                    className="btn btn-link font-weight-bold mr-2"
                    onClick={toggleAdicionandoConfiguracao}
                >
                    <FontAwesomeIcon className="mr-1" icon={faPlus} size="lg" />
                    Adicionar Configuração
                </button>
            </div>

            <Collapse in={adicionandoConfiguracao}>
                <CriarConfiguracaoTemplateFormulario
                    idFormulario={props.idFormulario}
                    then={updateList}
                />
            </Collapse>

            <div className="d-flex flex-wrap g-4 mt-4">
                <OrSpinner loading={loading}>
                    {lstTemplateVinculadosAoFormulario?.length ? (
                        lstTemplateVinculadosAoFormulario.map(
                            (templateVinculadoFormulario) => (
                                <LabelVinculoFormularioTemplate
                                    documentoFormulario={
                                        templateVinculadoFormulario
                                    }
                                    onDelete={updateList}
                                />
                            )
                        )
                    ) : (
                        <div className="text-center text-muted">
                            Nenhum template configurado para esse formulário
                        </div>
                    )}
                </OrSpinner>
                {}
            </div>
        </div>
    );
}
